import React, { Component } from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter, Route } from 'react-router-dom';
import Statistics from './common/statistics';

import './assets/css/reset.css';
import './assets/css/common.css';
import './assets/css/block.css';
import 'react-quill/dist/quill.core.css'
import 'react-quill/dist/quill.snow.css'


import List from './pages/list';
import Video from './pages/video';
import LoginName from './pages/manu/login';
import LoginTel from './pages/manu/logintel';
import Forget from './pages/manu/forget';
import Register from './pages/manu/register';

import store from './store';

class App extends Component {
	componentDidMount(){
		setTimeout(function(){
			if (window._czc) {
				let location = window.location
				let contentUrl = location.pathname + location.hash
				let refererUrl = '/'
				window._czc.push(['_trackPageview', contentUrl, refererUrl])
			}
		}, 1000)
	}
	
	render() {
		return (
			<Provider store={store}>
				<BrowserRouter basename="/wsppc/">
					<Statistics>
						<div className="App">
							<Route path="/" name="List" component={List} exact={true} needLogin={true}/>
							<Route path="/video/:classId" name="Video" component={Video} exact={true} needLogin={true}/>
							<Route path="/login" name="LoginName" component={LoginName} exact={true} needLogin={false}/>
							<Route path="/loginTel" name="LoginTel" component={LoginTel} exact={true} needLogin={false}/>
							<Route path="/forget" name="Forget" component={Forget} exact={true} needLogin={false}/>
							<Route path="/register" name="Register" component={Register} exact={true} needLogin={false}/>
						</div>
					</Statistics>
				</BrowserRouter>
			</Provider>
		)
	}
}


export default App;
